(() => {
	if (customElements.get('simple-carousel')) {
		return;
	}

	class SimpleCarousel extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				slider: null,
			}

			this.options = {
				waitForTransition: false,
        autoplay: false,
        interval: 5000,
				reiwnd: true,
				type: 'loop',
				perPage: 1,
				perMove: 1,
				drag: 'drag',
				pagination: true,
				arrows: false,
			};
		}

		connectedCallback() {
			this.initSlider();
		}

		initSlider() {
			if (!this.querySelector('.js-slider')) return;

			this.selectors.slider = new Splide(
				this.querySelector('.js-slider'),
				this.options
			).mount();
		}
	}

	customElements.define('simple-carousel', SimpleCarousel);
})();

